var map = {
	"./img/bomb1.svg": "VJEo",
	"./img/bomb2.svg": "4H2h",
	"./img/bruinvis-los.png": "IBsb",
	"./img/card_1950.png": "eit8",
	"./img/card_2010.png": "XmsR",
	"./img/effect/effect-bomb-a.png": "Xgnz",
	"./img/effect/effect-bomb-b.png": "jfXg",
	"./img/effect/effect-distance-a.png": "XYMl",
	"./img/effect/effect-distance-b.png": "SxLC",
	"./img/effect/effect-pole-a.png": "z4DX",
	"./img/effect/effect-pole-b.png": "dWRW",
	"./img/fish.svg": "0wID",
	"./img/game/gameMask.svg": "FV46",
	"./img/gameMask.svg": "mxLB",
	"./img/icons/arrows.svg": "AiHQ",
	"./img/icons/close.svg": "WlY0",
	"./img/icons/copy.svg": "wbUR",
	"./img/icons/facebook.svg": "T4Jl",
	"./img/icons/mail.svg": "QP6Z",
	"./img/icons/nosop3.svg": "t35w",
	"./img/icons/pause.svg": "V6TY",
	"./img/icons/play.svg": "Jln1",
	"./img/icons/twitter.svg": "mtjh",
	"./img/intro-image.gif": "d4Rs",
	"./img/more/more-airgun.png": "fb6k",
	"./img/more/more-bombs.png": "tqVg",
	"./img/more/more-ships.png": "trE4",
	"./img/more/more-sonars.png": "JQz7",
	"./img/more/more-windmills.png": "cjcd",
	"./img/solutions/solution-lesssound.png": "K8eB",
	"./img/solutions/solution-quietram.png": "U62T",
	"./img/solutions/solution-sail.png": "71oM",
	"./img/solutions/solution-slowfloat.png": "ut/K",
	"./img/solutions/solution-sucking.png": "ihie",
	"./img/solutions/solution-whalefriendly.png": "oX/m",
	"./img/thumb-small-video.png": "6CMS",
	"./img/thumb-video.png": "+00/",
	"./img/zaklamp.gif": "gthy",
	"./scss/_colors.scss": "+uiz",
	"./scss/_mixins.scss": "S8NU",
	"./scss/_type.scss": "OVnZ",
	"./scss/_variables.scss": "iTXB",
	"./scss/default.scss": "gmqg",
	"./videos/geluiden.mp4": "f3CX",
	"./videos/whales.mp4": "NsWZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0